module.exports = __webpack_public_path__ + "static/media/open-sans-regular.2491afe9.woff";